// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"02dc0289","254":"e2e28182","385":"6dba7398","421":"3c944107","608":"e8265aa0","618":"01e134e8","738":"bda229c7","774":"32fb70dc","850":"01ca5c54"}[chunkId] + ".chunk.js";
};